import { getEnv } from '@xbcb/ui-utils';

export interface ConnectProEndpoints {
  tabWidgetEndpoint: string;
  sideBarEndpoint: string;
  batchCaseActions: string;
  singleCaseDetailEndpoint: string;
  mainEndpoint: string;
  globalCaseListEndpoint: string;
}

export interface ConnectProSettings {
  endpoints: ConnectProEndpoints;
  region: string;
  domain: string;
}

// Endpoints for different environments
export const ENDPOINTS = {
  gamma: {
    tabWidgetEndpoint:
      'https://gamma.us-west-2.cpasset.cbms.global-mile.amazon.dev/XbcbConnectProWidgetAssets/connectServiceTabWidget.js',
    sideBarEndpoint:
      'https://gamma.us-west-2.cpasset.cbms.global-mile.amazon.dev/XbcbConnectProWidgetAssets/connectServiceSideBarWidget.js',
    batchCaseActions:
      'https://gamma.us-west-2.cpasset.cbms.global-mile.amazon.dev/XbcbConnectProWidgetAssets/caseActionsWidget.js',
    singleCaseDetailEndpoint:
      'https://gamma.us-west-2.cpasset.cbms.global-mile.amazon.dev/XbcbConnectProWidgetAssets/singleCaseDetailWidget.js',
    mainEndpoint:
      'https://gamma.us-west-2.cpasset.cbms.global-mile.amazon.dev/XbcbConnectProWidgetAssets/main.js',
    globalCaseListEndpoint:
      'https://gamma.us-west-2.cpasset.cbms.global-mile.amazon.dev/XbcbConnectProWidgetAssets/globalCaseListWidget.js',
  },
  beta: {
    tabWidgetEndpoint:
      'https://beta.us-west-2.cpasset.cbms.global-mile.amazon.dev/XbcbConnectProWidgetAssets/connectServiceTabWidget.js',
    sideBarEndpoint:
      'https://beta.us-west-2.cpasset.cbms.global-mile.amazon.dev/XbcbConnectProWidgetAssets/connectServiceSideBarWidget.js',
    batchCaseActions:
      'https://beta.us-west-2.cpasset.cbms.global-mile.amazon.dev/XbcbConnectProWidgetAssets/caseActionsWidget.js',
    singleCaseDetailEndpoint:
      'https://beta.us-west-2.cpasset.cbms.global-mile.amazon.dev/XbcbConnectProWidgetAssets/singleCaseDetailWidget.js',
    mainEndpoint:
      'https://beta.us-west-2.cpasset.cbms.global-mile.amazon.dev/XbcbConnectProWidgetAssets/main.js',
    globalCaseListEndpoint:
      'https://beta.us-west-2.cpasset.cbms.global-mile.amazon.dev/XbcbConnectProWidgetAssets/globalCaseListWidget.js',
  },
  prod: {
    tabWidgetEndpoint:
      'https://prod.us-west-2.cpasset.cbms.global-mile.amazon.dev/XbcbConnectProWidgetAssets/connectServiceTabWidget.js',
    sideBarEndpoint:
      'https://prod.us-west-2.cpasset.cbms.global-mile.amazon.dev/XbcbConnectProWidgetAssets/connectServiceSideBarWidget.js',
    batchCaseActions:
      'https://prod.us-west-2.cpasset.cbms.global-mile.amazon.dev/XbcbConnectProWidgetAssets/caseActionsWidget.js',
    singleCaseDetailEndpoint:
      'https://prod.us-west-2.cpasset.cbms.global-mile.amazon.dev/XbcbConnectProWidgetAssets/singleCaseDetailWidget.js',
    mainEndpoint:
      'https://prod.us-west-2.cpasset.cbms.global-mile.amazon.dev/XbcbConnectProWidgetAssets/main.js',
    globalCaseListEndpoint:
      'https://prod.us-west-2.cpasset.cbms.global-mile.amazon.dev/XbcbConnectProWidgetAssets/globalCaseListWidget.js',
  },
};

// Domain mapping for different environments
const DOMAINS = {
  gamma: 'gamma',
  beta: 'beta',
  prod: 'prod',
} as const;

export const getConnectProSettings = (): ConnectProSettings => {
  const { stage } = getEnv();
  const stageValue = stage.toLowerCase() as keyof typeof DOMAINS;

  const endpoints = ENDPOINTS[stageValue] || ENDPOINTS.gamma;
  const domain = DOMAINS[stageValue] || DOMAINS.gamma;

  return {
    endpoints,
    region: 'us-west-2',
    domain,
  };
};

// Pre-computed settings for convenience
export const connectProSettings = getConnectProSettings();
